module.exports = __webpack_public_path__ + "static/media/LogoNatureHumanBehaviour.e3536822.svg";